const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Helper function to get auth token
const getAuthToken = () => {
  const user = JSON.parse(localStorage.getItem('adminUser') || '{}');
  return user.token;
};

// Helper function to make authenticated requests
const makeRequest = async (url, options = {}) => {
  const token = getAuthToken();
  
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers,
    },
    ...options,
  };
  console.log("Making request to:", `${API_BASE_URL}${url}`, config);
  const response = await fetch(`${API_BASE_URL}${url}`, config);
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Something went wrong');
  }
  
  return response.json();
};

// Currency API functions
export const currencyAPI = {
  // Get all currencies
  getAll: () => makeRequest('/api/admin/currency'),
  
  // Create a new currency
  create: (currencyData) => makeRequest('/api/admin/currency', {
    method: 'POST',
    body: JSON.stringify({
      name: currencyData.name,
      display_order: currencyData.order,
      buying_rate: currencyData.buying,
      selling_rate: currencyData.selling,
      flag_image: currencyData.flag,
      currency_status: currencyData.status || 'active'
    }),
  }),
  
  // Update a currency
  update: (id, currencyData) => makeRequest(`/api/admin/currency/${id}`, {
    method: 'PUT',
    body: JSON.stringify({
      name: currencyData.name,
      display_order: currencyData.order,
      buying_rate: currencyData.buying,
      selling_rate: currencyData.selling,
      flag_image: currencyData.flag,
      currency_status: currencyData.status || 'active'
    }),
  }),
  
  // Delete a currency (soft delete)
  delete: (id) => makeRequest(`/api/admin/currency/${id}`, {
    method: 'DELETE',
  }),
  
  // Get currency history
  getHistory: (id) => makeRequest(`/api/admin/currency/${id}/history`),
};

// Flags API functions
export const flagsAPI = {
  // Get all available flags
  getAll: () => makeRequest('/api/admin/flags'),
};

// Stocks API functions
export const stocksAPI = {
  // Get all stock data
  getAll: () => makeRequest('/api/admin/stocks'),
  
  // Get real-time stock data
  getRealTime: () => makeRequest('/api/admin/stocks/realtime'),
  
  // Start the Finnhub service
  startService: () => makeRequest('/api/admin/stocks/start', { method: 'POST' }),
  
  // Stop the Finnhub service
  stopService: () => makeRequest('/api/admin/stocks/stop', { method: 'POST' }),
  
  // Add a new stock symbol
  addSymbol: (symbol) => makeRequest('/api/admin/stocks/symbols', {
    method: 'POST',
    body: JSON.stringify({ symbol }),
  }),
  
  // Remove a stock symbol
  removeSymbol: (symbol) => makeRequest(`/api/admin/stocks/symbols/${symbol}`, {
    method: 'DELETE',
  }),
  
  // Get service status
  getStatus: () => makeRequest('/api/admin/stocks/status'),
};

// Auth API functions
export const authAPI = {
  login: (credentials) => fetch(`${API_BASE_URL}/api/admin/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(credentials),
  }),
};
